import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PerfilState } from './perfil.state';
import { Perfil } from '../models/perfil.interface';

export const selectPerfilState = createFeatureSelector<PerfilState>('perfil');

export const selectAllPerfiles = createSelector(
  selectPerfilState,
  (state: PerfilState) => state.perfiles
);

export const selectSelectedPerfil = createSelector(
  selectPerfilState,
  (state: PerfilState) => state.selectedPerfil
);

export const selectPerfilLoading = createSelector(
  selectPerfilState,
  (state: PerfilState) => state.loading
);

export const selectPerfilError = createSelector(
  selectPerfilState,
  (state: PerfilState) => state.error
);

export const selectPerfilCreating = createSelector(
  selectPerfilState,
  (state: PerfilState) => state.creating
);

export const selectPerfilUpdating = createSelector(
  selectPerfilState,
  (state: PerfilState) => state.updating
);

export const selectPerfilDeleting = createSelector(
  selectPerfilState,
  (state: PerfilState) => state.deleting
);

export const selectPerfilSearchResults = createSelector(
  selectPerfilState,
  (state: PerfilState) => state.searchResults
);

export const selectPerfilSearchQuery = createSelector(
  selectPerfilState,
  (state: PerfilState) => state.searchQuery
);

export const selectPerfilById = createSelector(
  selectAllPerfiles,
  (perfiles: Perfil[], id: number) => perfiles.find(p => p.perfilId === id)
);

export const selectPerfilesCount = createSelector(
  selectAllPerfiles,
  (perfiles: Perfil[]) => perfiles.length
);
